// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__3de2d"};